/** @jsx jsx */
import { jsx } from 'theme-ui';
import { darken } from '@theme-ui/color';
import { useSafeArea } from '../hooks/useSafeArea';
import { useStatusBarStyle } from '../hooks/useStatusBarStyle';
import { StatusBarStyle } from '@capacitor/core';
export var FocusLayout = function (_a) {
    var className = _a.className, children = _a.children, title = _a.title, nav = _a.nav, footer = _a.footer;
    var topMargin = useSafeArea();
    useStatusBarStyle(StatusBarStyle.Light);
    return (jsx("div", { sx: {
            bg: 'dark',
            minHeight: '100vh',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            px: [3, 0],
        } },
        jsx("div", { sx: {
                p: 2,
                bg: 'white',
                left: 0,
                top: 0,
                right: 0,
                height: 200,
                borderColor: darken('dark', 0.1),
                borderWidth: 2,
                borderBottomStyle: 'solid',
                position: 'absolute',
                zIndex: 0,
            } }),
        jsx("div", { sx: {
                zIndex: 1,
                position: 'relative',
                mt: topMargin !== null && topMargin !== void 0 ? topMargin : 'env(safe-area-inset-top)',
            } },
            nav,
            jsx("div", { sx: { maxWidth: 450, mx: 'auto', mb: 3 }, className: className },
                title && (jsx("div", { sx: {
                        color: 'dark',
                        fontSize: 5,
                        fontWeight: 'bold',
                        mb: 3,
                    } }, title)),
                children)),
        footer));
};
//# sourceMappingURL=FocusLayout.js.map